import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { blockTransition, fadeIn } from 'src/app/theme/utils/app-animation';
import { MenuService } from 'src/app/shared/services/menu.service';
import { IMenu, landingPageMenuId } from 'src/app/shared/responses/imenu';

@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	animations: [blockTransition, fadeIn]
})
export class ErrorComponent implements AfterViewInit {

	settings: Settings;
	activeMenu: IMenu = { id: 1000, parentId: landingPageMenuId, title: 'Error', header: 'Error', routerLink: '/error', icon: 'mood_bad', desc: 'Opps, something went wrong..' };

	constructor(public appSettings: AppSettings, public router: Router, private readonly menuService: MenuService) {
		this.settings = this.appSettings.settings;

		// TODO: retrieve error message
		// const navigation = router.getCurrentNavigation();

		// console.log(`===============ErrorComponent navigation.extras.state:`);
		// console.log(navigation.extras.state);
	}

	goHome(): void {
		const homeUrl = this.menuService.getHomeUrl();

		this.router.navigate([homeUrl]);
	}

	ngAfterViewInit() {
		this.settings.loadingSpinner = false;
	}
}
